<template>

  <experiment class="exp" :experiment_type="experiment_type"></experiment>

</template>

<script>
import Experiment from './Experiment'

export default {
  name: 'experimentpage',
  props: ['experiment_type'],
  components: {
      Experiment
    },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
      testtest: function(){
        this.$parent.testClick();
      }
    
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ExperimentPage.vue?c22c445a